<script>
import { Line } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'

export default {
  name: 'line-example',
  components: {
    hexToRgba,
    CustomTooltips
  },
  extends: Line,
  mounted () {
    this.renderChart(
      {
        labels: ['Location1', 'Location2', 'Location3', 'Location4', 'Location5', 'Location6', 'Location7'],
        datasets: [
          {
            label: 'Assigned Keys',
            backgroundColor: hexToRgba('#E46651', 90),
            data: [30, 39, 10, 50, 30, 70, 35]
          },
          {
            label: 'Un-assigned keys',
            backgroundColor: hexToRgba('#00D8FF', 90),
            data: [39, 80, 40, 35, 40, 20, 45]
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
            }
          }
        }
      }
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/views/charts/LineExample.vue